import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import HomePage from './components/HomePage';
import SoftwareDetail from './components/SoftwareDetail';
import Navigation from './components/Navigation';
import Interesting from './components/Interesting';
import WorldCupPage from './components/WorldCupPage';
import './locales/i18n';
import './styles.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* 全局导航栏 */}
        <nav className="global-nav">
          <div className="nav-container">
            <div className="nav-links">
              <Link to="/" className="nav-link">
                软件下载
              </Link>
              <Link to="/navigation" className="nav-link">
                新闻导航
              </Link>
              <Link to="/interesting" className="nav-link">
                有趣的
              </Link>
              <Link to="/worldcup" className="nav-link">
                世界杯
              </Link>
            </div>
          </div>
        </nav>
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/software/:id" element={<SoftwareDetail />} />
          <Route path="/navigation" element={<Navigation />} />
          <Route path="/interesting" element={<Interesting />} />
          <Route path="/worldcup" element={<WorldCupPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;